import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=a59438d4&scoped=true&"
import script from "./Albums.vue?vue&type=script&lang=ts&"
export * from "./Albums.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59438d4",
  null
  
)

export default component.exports